import BgQuotes from "@/assets/svgs/backgrounds/BgQuotes";
import { COLORS } from "@/shared/constants/colors";
import { SuccessStoryType } from "@/shared/types/common.types";
import TestimonyCarouselCard from "./Cards/TestimonyCarouselCard";
import Carousel from "./Carousel";

export type TestimonyCarouselSectionPropType = {
  successStories: SuccessStoryType[];
};

const TestimonyCarouselSection = ({
  successStories,
}: TestimonyCarouselSectionPropType) => {
  return (
    <div className="relative bg-estimation-section pb-6 pt-12">
      {/* <BgSectionGradientGridLeft className="pointer-events-none absolute left-0 top-0 -z-0 opacity-50 mix-blend-multiply backdrop-filter" />
      <BgSectionGradientGridRight className="pointer-events-none absolute bottom-0 right-0 -z-0 opacity-50 mix-blend-multiply backdrop-filter" /> */}
      <div className="container">
        <div className="relative mx-auto max-w-xl">
          <BgQuotes
            className="-z-1 pointer-events-none absolute left-0 top-0 hidden -translate-x-2/3 -translate-y-1/2 rotate-180 scale-[200%] sm:block"
            fill={COLORS.GREY_00}
          />
          <Carousel>
            {successStories.map((successStory, index) => (
              <TestimonyCarouselCard successStory={successStory} key={index} />
            ))}
          </Carousel>
          <BgQuotes className="-z-1 pointer-events-none absolute bottom-10 right-0 sm:hidden" />
        </div>
      </div>
    </div>
  );
};

export default TestimonyCarouselSection;
